import { DropDownBoxComponentSpacing, DropDownBoxLayoutStyle, StateDropDown } from '@apply/components';
import { useWizardDemoStore } from '../../../../../state/wizardDemoStore';

export const StateField = () => {
    const value = useWizardDemoStore((state) => state.property.state);
    // Clears the county when the state changes (see the store action)
    const setPropertyState = useWizardDemoStore((state) => state.setPropertyState);

    return (
        <StateDropDown
            id='propertyState'
            value={value}
            onChange={(state) => setPropertyState(state ?? '')}
            label='State'
            required={true}
            width={'auto'}
            placeholder='Select'
            componentSpacing={DropDownBoxComponentSpacing.StandardSpacing}
            layoutStyle={DropDownBoxLayoutStyle.Horizontal}
            height='36px'
        />
    );
};
